module.exports = __webpack_public_path__ + "img/brand_name_brand_promise_card.dc95b804.svg";